import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Keyboard } from "lucide-react";
import { SHORTCUT_LIST, SHORTCUT_LIST_ADMIN } from "../hooks/useKeyboardShortcuts";

function KeyChip({ children }) {
  return (
    <kbd className="inline-flex items-center justify-center min-w-[26px] h-[26px] px-2 border border-slate-300 bg-slate-50 font-mono-num text-[11px] font-black text-[#0D9488] tracking-wide">
      {children}
    </kbd>
  );
}

function Row({ keys, label }) {
  return (
    <div className="flex items-center justify-between gap-4 py-2 border-b border-slate-200 last:border-b-0">
      <span className="text-sm text-slate-800">{label}</span>
      <div className="flex items-center gap-1.5 shrink-0">
        {keys.map((k, i) => (
          <>
            <KeyChip key={`${k}-${i}`}>{k}</KeyChip>
            {i < keys.length - 1 && <span className="text-slate-400 text-[10px] font-mono-num">then</span>}
          </>
        ))}
      </div>
    </div>
  );
}

export default function ShortcutHelpDialog({ open, onOpenChange, isAdmin = false }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-white border border-slate-200 text-slate-900 rounded-none max-w-lg"
        data-testid="shortcut-help-dialog"
      >
        <DialogHeader>
          <div className="font-mono-num text-[11px] uppercase tracking-[0.3em] text-[#0D9488] mb-1 flex items-center gap-1.5">
            <Keyboard className="w-3.5 h-3.5" />
            // KEYBOARD SHORTCUTS
          </div>
          <DialogTitle className="font-display uppercase tracking-tight text-2xl font-black">
            Move faster
          </DialogTitle>
          <DialogDescription className="text-slate-500 text-xs mt-1">
            Press <KeyChip>G</KeyChip> then a follow-up key to jump between pages. Press <KeyChip>?</KeyChip> anytime to reopen this list.
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          <div className="font-mono-num text-[10px] uppercase tracking-[0.25em] text-slate-500 pb-2 border-b border-slate-200">
            // Navigation
          </div>
          <div className="divide-y divide-zinc-900">
            {SHORTCUT_LIST.map((s) => (
              <Row key={s.label} keys={s.keys} label={s.label} />
            ))}
          </div>
          {isAdmin && (
            <>
              <div className="mt-4 font-mono-num text-[10px] uppercase tracking-[0.25em] text-[#0D9488] pb-2 border-b border-slate-200">
                // Admin
              </div>
              <div className="divide-y divide-zinc-900">
                {SHORTCUT_LIST_ADMIN.map((s) => (
                  <Row key={s.label} keys={s.keys} label={s.label} />
                ))}
              </div>
            </>
          )}
          <div className="mt-5 pt-3 border-t border-slate-200 text-[11px] text-slate-500 font-mono-num leading-relaxed">
            Shortcuts are disabled while you're typing in inputs, textareas, or the community composer.
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
